const init = () => {
	const faqAnchors = document.querySelectorAll('.accordion-header');
	const anchors = Array.prototype.slice.call(faqAnchors);

	if (faqAnchors.length == 0) {
		return;
	}

	// Listen for clicks on panel headers
	anchors.forEach(anchor => {
		anchor.addEventListener('click', updateHash);
	});

	// set the data-id property as the hash
	function updateHash(e) {
		window.location.hash = e.target.dataset.id;
	}

	// Open the panel corresponding to the url hash
	function manuallyOpenPanel(id) {
		const panelHeader = document.querySelector(
			'button[data-id="' + id + '"'
		);
		panelHeader.click();
	}

	// read the url hash
	function readHash() {
		if (window.location.hash) {
			const term = window.location.hash.substr(1);
			manuallyOpenPanel(term);
		}
	}
	// Read the url hash when the page loads
	document.addEventListener('DOMContentLoaded', function() {
		readHash();
	});
};

init();
